import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ParteDetallePage } from '../pages/parte-detalle/parte-detalle'
import { CuadrillaDetallePage } from '../pages/cuadrilla-detalle/cuadrilla-detalle'
import { PersonalDetallePage } from '../pages/personal-detalle/personal-detalle'
import { VariedadesDetallePage } from '../pages/variedades-detalle/variedades-detalle'
//import { PartesPage } from '../pages/partes/partes'
//import { CuadrillasPage } from '../pages/cuadrillas/cuadrillas'

import { PcTabsPage } from '../pages/pc-tabs/pc-tabs';
import { PartesService } from '../services/partes.services';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, /*AngularFireDatabase*/ } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthProvider } from '../providers/auth/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyBr_TnbStKYkXnMFqkkfstkd1xxqeTXlbM",
  authDomain: "pcrecol.firebaseapp.com",
  databaseURL: "https://pcrecol.firebaseio.com",
  storageBucket: "pcrecol.appspot.com",
  messagingSenderId: '138534963741'
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ParteDetallePage,
    CuadrillaDetallePage,
    PersonalDetallePage,
    VariedadesDetallePage,
    PcTabsPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {tabsHideOnSubPages: true,}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ParteDetallePage,
    CuadrillaDetallePage,
    PersonalDetallePage,
    VariedadesDetallePage,
    PcTabsPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    PartesService,
    AuthProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts